import { render, staticRenderFns } from "./TableListItems.vue?vue&type=template&id=1ffc2c78"
import script from "./TableListItems.vue?vue&type=script&lang=js"
export * from "./TableListItems.vue?vue&type=script&lang=js"
import style0 from "./TableListItems.vue?vue&type=style&index=0&id=1ffc2c78&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ffc2c78')) {
      api.createRecord('1ffc2c78', component.options)
    } else {
      api.reload('1ffc2c78', component.options)
    }
    module.hot.accept("./TableListItems.vue?vue&type=template&id=1ffc2c78", function () {
      api.rerender('1ffc2c78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TableListItems.vue"
export default component.exports